/** @module others/rfcPreUploadUi */
import $ from 'jquery';
import hooks from '../util/hooks';
import { ajax } from '../util';
import rmlOpts from 'rmlopts';

/**
 * Load data to a dropdown or show label that the folder is inherited from the AppTree.
 * This RFC is placed in the upload UI where you can select your files.
 * 
 * @function preUploadUi
 * @listens module:util/hooks#wprfc/$function
 */
hooks.register('wprfc/preUploadUi', async function(data) {
    const attachmentsBrowser = $(this).parents('.attachments-browser');
    if (attachmentsBrowser.length) {
        $(this).parent().hide().prev().html(rmlOpts.lang.uploaderUsesLeftTree);
    }else{
        const { html } = await ajax('tree/dropdown');
        $(this).addClass('attachments-filter-preUploadUi').html(html);
    }
});